import React from "react";


class KeysuccessInfoPrizes extends React.Component {

    constructor(props) {

        super(props)
        this.state = {
            type : ''
        }
    }

    updateSelectedCheck = (type) => {

        this.setState({ type : type})
    }

    render() {


        return(
            <div className="key_success_imgPopup">
            <img src="images/keys_success_img2.jpg" alt="" className="w-100" />
            <div className="key_success_arrow float-right">
            <a href="#" onClick={() => { this.props.changeModalPopupDisplayData('keysuccess_rules') }}><img src="images/pop_left_arrow.png" alt="" className="mr-3" /></a>
                <a href="#" onClick={() => { this.props.changeModalPopupDisplayData('keysuccess_progress') }}><img src="images/pop_right_arrow.png" alt="" className="" /></a>
            </div>
            
            <div className="pop_redio_div">
                <label className="redio_btn_div"
                
                onMouseOver={ () => this.updateSelectedCheck('progress')}
                onMouseLeave={ () => this.updateSelectedCheck('')}
                >See My Progress
                    <input type="radio"  name="radio" value="progress"    checked={this.state.type === "progress"}
                                    onClick={() => { 
                                        this.setState({ type : 'progress'})
                                    this.props.changeModalPopupDisplayData('keysuccess_progress') 

                                    }}

                                    />
                    <span className="checkmark"
                    
                    ></span>
                </label>
                <label className="redio_btn_div"                  
                onMouseOver={() => this.updateSelectedCheck('rules')}
                onMouseLeave={() => this.updateSelectedCheck('')}
                >Rules
                    <input type="radio"  name="radio" value="rules"   checked={this.state.type === "rules"}
                                    onClick={() => { this.setState({ type : 'rules'})
                                    this.props.changeModalPopupDisplayData('keysuccess_rules') 

                                    }}
                  
                                    />
                    <span className="checkmark"
                                        
                    
                    ></span>
                </label>
            </div>
        </div>
        )
       
       
    }
}

export default KeysuccessInfoPrizes;